import loadable, { lazy } from "@loadable/component";
import FeatureNotFound from "components/common/FeatureNotFound";
import LoadingPage from "components/desktop/LoadingPage";
import { PATH, userPath } from "constants/path";
import { DefaultLayout } from "layouts/desktop/DefaultLayout";
import FooterContentLayout from "layouts/desktop/FooterContentLayout";
import { UserLayout } from "layouts/desktop/UserLayout";
import MemberVipPage from "pages/common/MemberVipPage";
import ChangePasswordWithdraw from "pages/desktop/ChangePasswordWithdraw";
import FavouriteGamePage from "pages/desktop/FavouriteGamePage";
import VipDetails from "pages/desktop/VipDetails";
import { Suspense } from "react";
import { RouteObject } from "react-router-dom";

import ProtectedRoute from "./protected";

const AboutUsPage = loadable(() => import("pages/common/AboutUsPage"));
const App = lazy(() => import("../App"));
const ContactUsPage = loadable(() => import("pages/common/ContactUsPage"));
const DisclaimerPage = loadable(() => import("pages/common/DisclaimerPage"));
const FAQPage = loadable(() => import("pages/common/FAQPage"));
const PartnerPage = loadable(() => import("pages/common/PartnerPage"));
const PrivacyPage = loadable(() => import("pages/common/PrivacyPage"));
const PromotionDevelopPage = loadable(
  () => import("pages/common/PromotionDevelopPage"),
);
const PromotionPage = loadable(() => import("pages/common/PromotionPage"));
const ResponsiblePage = loadable(() => import("pages/common/ResponsiblePage"));
const RulePage = loadable(() => import("pages/common/RulePage"));
const InternalMallPage = loadable(() => import("pages/desktop/InternalMall"));
const SecuritySettingPage = loadable(
  () => import("pages/desktop/SecuritySettingPage"),
);
const HomePage = loadable(() => import("pages/desktop/HomePage"));
const GamePage = loadable(() => import("pages/desktop/GamePage"));
const DepositPage = loadable(() => import("pages/desktop/DepositPage"));
const WithdrawPage = loadable(() => import("pages/desktop/WithdrawPage"));
const AnnounceMentPage = loadable(() => import("pages/desktop/Announcement"));
const BettingHistoryPage = loadable(
  () => import("pages/desktop/BettingHistory"),
);
const TransactionHistoryPage = loadable(
  () => import("pages/desktop/Transaction"),
);
const HistoryUpdateVip = loadable(
  () => import("pages/desktop/HistoryUpdateVip"),
);
const AwardVip = loadable(() => import("pages/desktop/AwardVip"));
const RefundPage = loadable(() => import("pages/desktop/RefundPage"));

export const DesktopRoutes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<LoadingPage />}>
        <App />
      </Suspense>
    ),
    children: [
      {
        element: <DefaultLayout />,
        children: [
          {
            path: PATH.Home,
            element: <HomePage />,
          },
          {
            path: PATH.Promotion,
            element: <PromotionPage />,
          },
          {
            path: "/promotion/develop",
            element: <PromotionDevelopPage />,
          },
          {
            path: PATH.GamePage,
            element: <GamePage />,
          },
          {
            path: PATH.ProviderPage,
            element: <GamePage />,
          },
          {
            element: <FooterContentLayout />,
            children: [
              {
                path: PATH.AboutUs,
                element: <AboutUsPage />,
              },
              {
                path: PATH.ContactUs,
                element: <ContactUsPage />,
              },
              {
                path: PATH.Privacy,
                element: <PrivacyPage />,
              },
              {
                path: PATH.Rule,
                element: <RulePage />,
              },
              {
                path: PATH.FAQ,
                element: <FAQPage />,
              },
              {
                path: PATH.Disclaimer,
                element: <DisclaimerPage />,
              },
              {
                path: PATH.ResponsibleGambling,
                element: <ResponsiblePage />,
              },
              {
                path: PATH.Partner,
                element: <PartnerPage />,
              },
            ],
          },
          {
            element: <ProtectedRoute />,
            children: [
              {
                path: userPath,
                element: <UserLayout />,
                children: [
                  {
                    path: PATH.User.Deposit,
                    element: <DepositPage />,
                  },

                  {
                    path: PATH.User.Withdraw,
                    element: <WithdrawPage />,
                  },
                  {
                    path: PATH.User.SecuritySetting,
                    element: <SecuritySettingPage />,
                  },
                  {
                    path: PATH.User.Announcement,
                    element: <AnnounceMentPage />,
                  },
                  {
                    path: PATH.User.BettingHistory,
                    element: <BettingHistoryPage />,
                  },
                  {
                    path: PATH.User.Transactions,
                    element: <TransactionHistoryPage />,
                  },
                  {
                    path: PATH.User.HistoryUpdateVip,
                    element: <HistoryUpdateVip />,
                  },
                  {
                    path: PATH.User.AwardVip,
                    element: <AwardVip />,
                  },
                  {
                    path: PATH.User.MemberVip,
                    element: <MemberVipPage />,
                  },

                  {
                    path: PATH.User.Refund,
                    element: <RefundPage />,
                  },
                  {
                    path: PATH.User.Event,
                    element: <PromotionPage />,
                  },
                  {
                    path: PATH.User.InternalMail,
                    element: <InternalMallPage />,
                  },
                  {
                    path: PATH.User.FavouriteGame,
                    element: <FavouriteGamePage />,
                  },
                  {
                    path: "*",
                    element: <FeatureNotFound />,
                  },
                  {
                    path: PATH.User.changePasswordWithdraw,
                    element: <ChangePasswordWithdraw />,
                  },
                ],
              },
              {
                element: <VipDetails />,
                path: PATH.User.MemberVipDetail,
              },
            ],
          },
        ],
      },
    ],
  },
];
